module.exports = __webpack_public_path__ + "static/media/block-4-ipswich.78fde0f1.png";